import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { AgentResponse, CreateOrUpdateAgentRequest } from "./agentsApi";
import { createAgent } from "./agentsApi";

export const useCreateAgent = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const createAgentMutation = useMutation<AgentResponse, unknown, CreateOrUpdateAgentRequest>({
    mutationFn: (r) => createAgent(r),
    onSuccess: async (r) => {
      enqueueSnackbar(`Przedstawiciel ${r.name} został utworzony`, { variant: "success" });
      queryClient.setQueryData(["agents", r.id], r);
      await queryClient.invalidateQueries({ queryKey: ["agents"] });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się utworzyć przedstawiciela. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });

  return {
    createAgent: (request: CreateOrUpdateAgentRequest) => createAgentMutation.mutateAsync(request),
  };
};
